import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-styled-flexboxgrid'

import FullName from '~/components/traffic-tickets/steps/UserInfo/FullName'
import Email from '~/components/traffic-tickets/steps/UserInfo/Email'
import PhoneNumber from '~/components/traffic-tickets/steps/UserInfo/PhoneNumber'
import TABLE_SIZES from './tableSizes'

// Notched (parking) contact layout. Plain divs (no flexboxgrid) so the
// NotchedFields stay full-width (no Col padding inset). Desktop: name + phone
// share a row at 50/50 with a 16px gap; email full-width below. Narrow
// (<= smallDesktop): all stack full-width. 16px gap throughout (flex gap -- no
// collapse).
const ContactGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

const NamePhoneRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  > * {
    flex: 1 1 0;
    min-width: 0;
  }
  ${(p) => p.theme.media.smallDesktop`
    flex-direction: column;
    > * {
      flex: 1 1 100%;
    }
  `}
`

const InputRowNoPassword = ({ notched }) => {
  if (notched) {
    return (
      <ContactGrid>
        <NamePhoneRow>
          <FullName notched />
          <PhoneNumber notched />
        </NamePhoneRow>
        <Email notched />
      </ContactGrid>
    )
  }
  return (
    <Row>
      <Col {...TABLE_SIZES.fullName}>
        <FullName />
      </Col>
      <Col {...TABLE_SIZES.phoneNumber}>
        <PhoneNumber />
      </Col>
      <Col {...TABLE_SIZES.email}>
        <Email />
      </Col>
    </Row>
  )
}

export default InputRowNoPassword
